module.exports = __webpack_public_path__ + "images/category_info/icon-bg_4c459df8a7f1bad80596398304e03922.png";